<template>
  <div class="modal warning fade" :class="{'is-open': open}">
    <div class="modal-dialog modal-sm">
      <div class="modal-content">
        <div class="modal-body">
          <div class="warning　d-flex justify-content-between">
            <img
              width="48"
              :src="`${BaseUrl}assets/common/warning.png`"
              :srcset="`${BaseUrl}assets/common/warning@2x.png`"
            />
            <!--  兩個頁籤 vue 共用此 modal  -->
            <content>
              <slot name="content"></slot>
            </content>
          </div>
          <div class="action text-right" v-show="showConfirmBtn">
            <a @click="$emit('close')" class="btn btn-primary w-120">確定</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "mvInfo",
  computed: {
    ...mapGetters(["BaseUrl"]),
  },
  props: {
    open: {
      type: Boolean,
      default: false,
    },
    inputData: {
      type: String,
      default: "",
    },
    showConfirmBtn: {
      type: Boolean,
      default: true,
    }
  },
  methods: {},
};
</script>